import { render, staticRenderFns } from "./ToTopBtn.vue?vue&type=template&id=49b23825"
import script from "./ToTopBtn.vue?vue&type=script&lang=ts"
export * from "./ToTopBtn.vue?vue&type=script&lang=ts"
import style0 from "./ToTopBtn.vue?vue&type=style&index=0&id=49b23825&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports